export class SetLastPageProjectView {
    public static readonly type = "[Projects] Save App last page was project view";

    constructor(public payload: boolean) {}
}
